export const JWT_KEY = "jwtToken";
